import createReducer from 'utils/redux/createReducer'

const initialState = []

export default createReducer(initialState, {
	GOT_PHOTO: (photoList, action) => [...photoList, action.data]
})



// WEBPACK FOOTER //
// ./src/reducers/photoList.js